export enum ContactsType {
  INFORMATIONAL = 'informational',
  LINKS = 'links',
  APPEALS = 'appeals',
  CUSTOMER_SERVICE = 'customer_service',
}

export enum ContactsBtnText {
  OPEN_LINK = 'Открыть документ',
  CREATE_APPAL_ATOL = 'Создать обращение в АТОЛ Connect',
  CREATE_APPERAL = 'Создать обращение',
}

export const info_message = 'Опишите свой вопрос или проблему, и при необходимости прикрепите файлы. После сохранения формы, на электронную почту менеджера будет отправлено письмо.';
